import React, { Component, Fragment } from 'react';
import { Button } from 'reactstrap';
import swal from 'sweetalert';
import _ from 'lodash';
import FleetManagerService from '../../../services/FleetManagerService';
import FleetService from '../../../services/FleetService';

class RejectEntriesDropDown extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      rejectRemarks: [],
      isMobile: false,
      rejectRemarkControlValue: '',
      showCommentBox: false,
      comment: '',
      isInvalid: true
    };
    this.toggle = this.toggle.bind(this);
  }

  componentWillMount() {
    this.getRejectRemark();
  }

  componentDidMount() {
    let { isMobile } = this.state;
    isMobile = FleetService.checkUserAgent();
    this.setState({ isMobile });
  }

  handleInputChange = (e) => {
    const { rejectRemarks } = this.state;
    let { isInvalid } = this.state;
    let { rejectRemarkControlValue, comment, showCommentBox } = this.state;
    isInvalid = true;
    if (e.target.name === 'rejectRemarkControlValue') {
      rejectRemarkControlValue = (_.find(rejectRemarks, (remark) => {
        return remark.id.toString() === e.target.value;
      }) || {}).remark;

      showCommentBox = false;
      if (e.target.value === 4 || e.target.value === '4') {
        showCommentBox = true;
      }
    } else {
      comment = e.target.value;
    }

    if ((e.target.value === 4 || e.target.value === '4') && rejectRemarkControlValue && comment) {
      isInvalid = false;
    } else if ((e.target.value !== 4 || e.target.value !== '4') && rejectRemarkControlValue) {
      isInvalid = false;
    }

    this.setState({ rejectRemarkControlValue, comment, showCommentBox, isInvalid });
  }

  getRejectRemark = async () => {
    let { rejectRemarks } = this.state;
    try {
      const { data } = await FleetManagerService.getRejectRemark();

      if (data) {
        rejectRemarks = data.data;
      }
      this.setState({ rejectRemarks });
    } catch (error) {
      console.log(error);
    }
  }

  noClick = () => {
    swal.close();
  }

  yesClick = () => {
    const { rejectRemarkControlValue, comment } = this.state;
    this.props.onRejectMarkYesClick(rejectRemarkControlValue, comment);
    swal.close();
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  render() {
    const { isInvalid, rejectRemarks, isMobile, showCommentBox } = this.state;

    return (
      <div>
        <div style={isMobile ? { marginLeft: '-13px' } : { marginLeft: '-20px' }}>
          <img src="images/warning.svg" alt="" style={isMobile ? { marginTop: '0px' } : { marginTop: '-5px' }} />
          <span className="swal-reject-modal-title">Are you sure you want to reject the verification request?</span>
        </div>
        <hr />
        {/* <Label for="phone">Area <span className="required-field">*</span></Label> */}
        <div style={{ width: '88%', margin: 'auto' }}>
          <span className="Please-choose-your-reject" style={isMobile ? { marginLeft: '0px' } : { marginLeft: '-166px' }}>Please choose your reason to reject the request</span>
          <select className="form-control select-height-70rem" name="rejectRemarkControlValue"
            onChange={(e) => this.handleInputChange(e)}>
            <option value="" selected disabled>Select</option>
            {
              (rejectRemarks || []).map((item) => (
                <option key={item.remark} value={item.id}>{item.remark}</option>
              ))
            }
          </select>
          {
            showCommentBox && <Fragment>
              <br />
              <span className="Please-choose-your-reject" style={isMobile ? { marginLeft: '0px' } : { marginLeft: '-325px' }}>Please enter comment</span>
              <textarea className="form-control" name="comment" onChange={(e) => this.handleInputChange(e)} placeholder="Type here" />
            </Fragment>
          }

        </div>
        <br />
        <div className="pull-right" style={{ paddingBottom: '14px' }}>
          <Button className="mb-1 mr-1 btn-pill action-button c-btn-grey" color="primary" onClick={this.noClick}>No</Button>
          <Button disabled={isInvalid} className="mb-1 mr-1 btn-pill action-button c-btn-orange" color="primary" onClick={this.yesClick}>Yes</Button>
        </div>
      </div>
    );
  }
}

export default RejectEntriesDropDown;